import { apiService } from "@/services/apiService";
import { endpoints } from "@/config/endpoints";
import { pickBy } from "lodash";

export default {
  postPeriodicChart({
    keywords,
    period,
    report_type,
    gmb_address_ids,
    groups,
    cities,
    date_from,
    date_to
  }) {
    const payload = {
      keywords,
      period,
      report_type,
      gmb_address_ids,
      groups,
      cities,
      date_from,
      date_to
    };
    return apiService.post(endpoints.periodicRankings, payload);
  },

  postPeriodicTable({
    page,
    perPage,
    keywords,
    period,
    report_type,
    gmb_address_ids,
    groups,
    cities,
    date,
    order_by,
    order_direction,
    is_grouped = false
  }) {
    const payload = {
      keywords,
      period,
      report_type,
      gmb_address_ids,
      groups,
      cities,
      date,
      is_grouped
    };

    const params = {
      page: page || 1,
      page_size: perPage || 10,
      order_by,
      order_direction
    };
    return apiService.post(endpoints.periodicRankingsTable, payload, {
      params: pickBy(params)
    });
  },

  postPeriodicTableSummary({
    keywords,
    period,
    report_type,
    gmb_address_ids,
    groups,
    cities,
    date
  }) {
    const payload = {
      keywords,
      period,
      report_type,
      gmb_address_ids,
      groups,
      cities,
      date
    };

    return apiService.post(endpoints.periodicRankingsTableSummary, payload);
  },

  periodicRankingsTableExport({
    keywords,
    period,
    report_type,
    gmb_address_ids,
    groups,
    cities,
    date,
    order_by,
    order_direction,
    is_grouped = false
  }) {
    const payload = {
      keywords,
      period,
      report_type,
      gmb_address_ids,
      groups,
      cities,
      date,
      is_grouped
    };

    const params = {
      order_by,
      order_direction
    };

    return apiService.post(endpoints.periodicRankingsTableExport, payload, {
      params: pickBy(params)
    });
  }
};
